import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DATA_SAMPLING_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const UPDATE_DATA_SAMPLING: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${DATA_SAMPLING_FRAGMENT}
  ${ERROR_FRAGMENT}

  mutation updateDataSampling($input: UpdateWorkspaceInput!) {
    updateWorkspace(input: $input) {
      workspace {
        ...dataSamplingFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
